export default __webpack_public_path__ + "static/media/logoMock.c483a549.png";